import React from "react";
import { ReactComponent as LinkBlack } from "../../assets/settingPage/sideBar/link 2.svg";
import { ReactComponent as UserBlack } from "../../assets/settingPage/sideBar/user-square.svg";
import { ReactComponent as LockBlack } from "../../assets/settingPage/sideBar/lock.svg";
import { ReactComponent as GlobeIcon } from "../../assets/landingPages/header/globe.svg";
import { ReactComponent as DollarBlack } from "../../assets/settingPage/sideBar/dollar-circle.svg";
import { ReactComponent as DollarWhite } from "../../assets/settingPage/sideBar/dollar-circle 2.svg";
import { NavLink } from "react-router-dom";
import { useStateContext } from "../../contexts/ThemeContext";
import useLocales from "../../hooks/useLocales";
import { useSelector } from "react-redux";

// Setting pages menu items

const SettingSideBar = () => {
  const { darkMode } = useSelector((state) => state.theme);
  const { translate } = useLocales();
  const { activeSettingSubNav } = useStateContext();

  const activeLink =
    "bg-gradient-to-br from-[#f8755c] to-[#FF5349] text-white  w-full rounded-full p-[7px] text-small1_bold px-[15px] flex gap-[15px] items-center";
  return (
    <>
      <div className="min-w-[195px] flex flex-col gap-4 mt-[47px]">
        <NavLink
          style={{
            boxShadow:
              activeSettingSubNav === "page"
                ? `${
                    darkMode
                      ? ""
                      : "-10px 15px 20px 0px rgba(217, 217, 217, 0.30), 0px 0px 10px 0px rgba(217, 217, 217, 0.10)"
                  }`
                : null,
          }}
          to={"page"}
          className={({ isActive }) =>
            isActive
              ? activeLink
              : "w-full rounded-full text-dark_bg_v2 p-[7px] text-small1 px-[15px] flex gap-[15px] items-center" &&
                activeSettingSubNav === "page"
              ? activeLink
              : "w-full text-dark_bg_v2 dark:text-color_v1_dark rounded-full p-[7px] text-small1 px-[15px] flex gap-[15px] items-center"
          }
        >
          <LinkBlack
            className={`${
              activeSettingSubNav === "page"
                ? "stroke-white"
                : darkMode
                ? "stroke-[#FFFFFF]"
                : "stroke-[#1E1E1E]"
            }`}
          />
          {translate("addBlock.page")}
        </NavLink>
        <NavLink
          to={"account"}
          style={{
            boxShadow:
              activeSettingSubNav === "account"
                ? `${
                    darkMode
                      ? ""
                      : "-10px 15px 20px 0px rgba(217, 217, 217, 0.30), 0px 0px 10px 0px rgba(217, 217, 217, 0.10)"
                  }`
                : null,
          }}
          className={({ isActive }) =>
            isActive
              ? activeLink
              : "w-full rounded-full text-dark_bg_v2 dark:text-color_v1_dark p-[7px] text-small1 px-[15px] flex gap-[15px] items-center"
          }
        >
          <UserBlack
            className={`${
              activeSettingSubNav === "account"
                ? "stroke-white"
                : darkMode
                ? "stroke-[#FFFFFF]"
                : "stroke-[#1E1E1E]"
            }`}
          />
          {translate("addBlock.account")}
        </NavLink>
        <NavLink
          to={"security"}
          style={{
            boxShadow:
              activeSettingSubNav === "security"
                ? `${
                    darkMode
                      ? ""
                      : "-10px 15px 20px 0px rgba(217, 217, 217, 0.30), 0px 0px 10px 0px rgba(217, 217, 217, 0.10)"
                  }`
                : null,
          }}
          className={({ isActive }) =>
            isActive
              ? activeLink
              : "w-full rounded-full text-dark_bg_v2 dark:text-color_v1_dark p-[7px] text-small1 px-[15px] flex gap-[15px] items-center"
          }
        >
          <LockBlack
            className={`${
              activeSettingSubNav === "security"
                ? "stroke-[#fff]"
                : darkMode
                ? "stroke-[#FFFFFF]"
                : "stroke-[#1E1E1E]"
            }`}
          />
          {translate("addBlock.security")}
        </NavLink>
        <NavLink
          to={"billings"}
          style={{
            boxShadow:
              activeSettingSubNav === "billings"
                ? `${
                    darkMode
                      ? ""
                      : "-10px 15px 20px 0px rgba(217, 217, 217, 0.30), 0px 0px 10px 0px rgba(217, 217, 217, 0.10)"
                  }`
                : null,
          }}
          className={({ isActive }) =>
            isActive
              ? activeLink
              : "w-full rounded-full text-dark_bg_v2 dark:text-color_v1_dark p-[7px] text-small1 px-[15px] flex gap-[15px] items-center"
          }
        >
          {activeSettingSubNav === "billings" ? (
            <DollarWhite />
          ) : darkMode ? (
            <DollarWhite />
          ) : (
            <DollarBlack />
          )}
          {translate("addBlock.billings")}
        </NavLink>

        {/*  <NavLink
          to={'language'}
          style={{
            boxShadow:
              activeSettingSubNav === 'language'
                ? '-10px 15px 20px 0px rgba(217, 217, 217, 0.30), 0px 0px 10px 0px rgba(217, 217, 217, 0.10)'
                : null,
          }}
          className={({ isActive }) =>
            isActive
              ? activeLink
              : 'w-full rounded-full text-dark_bg_v2 dark:text-color_v1_dark p-[7px] text-small1 px-[15px] flex gap-[15px] items-center'
          }
        >
          {activeSettingSubNav === 'language' ? (
            <GlobeIcon />
          ) : (
            <GlobeIcon style={{width:'20px'}}/>
          )}
          {translate('language')}
          </NavLink> */}
      </div>
    </>
  );
};

export default SettingSideBar;
